import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translations } from '../i18n/translations';
import { translationsExtra } from '../i18n/translationsExtra';
import { LANGUAGES } from '../mock/mock';

const ALL = { ...translations, ...translationsExtra };

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('arge_lang') || 'en');

  const meta = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    localStorage.setItem('arge_lang', lang);
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('dir', meta.dir);
  }, [lang, meta.dir]);

  // Dot-notation getter with English fallback.
  const t = useCallback((path) => {
    const dig = (obj) => path.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);
    const val = dig(ALL[lang]);
    if (val !== undefined) return val;
    const fb = dig(ALL.en);
    return fb !== undefined ? fb : path;
  }, [lang]);

  const value = { lang, setLang, dir: meta.dir, isRTL: meta.dir === 'rtl', t, languages: LANGUAGES };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};
